/**
 * main.js — Wallop Toolkit Entry Point
 *
 * Single entry point bundled by Vite into dist/wallop-toolkit.js.
 * CSS is imported here so Vite extracts it to dist/wallop-toolkit.css.
 *
 * Init order:
 *   1. Lenis smooth scroll (if <body> has [data-smooth-scroll])
 *   2. Scroll Reveal — IO-based entrance animations
 *   3. Parallax — Lenis-driven (or native scroll fallback) parallax
 *   4. Page Transitions — cross-document view transitions (Lenis cleanup)
 */

import "./scroll-reveal.css";
import "./transitions.css";
import { initLenis } from "./lenis.js";
import { initScrollReveal } from "./scroll-reveal.js";
import { initParallax } from "./parallax.js";
import { initTransitions } from "./transitions.js";

document.addEventListener("DOMContentLoaded", () => {
  initLenis();
  initScrollReveal();
  initParallax();
  initTransitions();
});
